var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singer-form" },
    [
      _c(
        "el-form",
        {
          ref: "signatoryTip",
          attrs: { model: _vm.signatory, rules: _vm.rules, size: "small" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "emailOrPhone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "签署方接收手机/邮箱" },
                on: {
                  blur: function($event) {
                    return _vm.handlerTargetIdBlur(_vm.signatory.emailOrPhone)
                  }
                },
                model: {
                  value: _vm.signatory.emailOrPhone,
                  callback: function($$v) {
                    _vm.$set(_vm.signatory, "emailOrPhone", $$v)
                  },
                  expression: "signatory.emailOrPhone"
                }
              })
            ],
            1
          ),
          _vm.signatory.canSelectArray &&
          ((+_vm.signatory.signatoryUserType === 1 &&
            _vm.signatory.canSelectArray.length > 0 &&
            !_vm.signatory.ManualInput) ||
            (+_vm.signatory.signatoryUserType === 0 &&
              _vm.signatory.canSelectArray.length > 1))
            ? [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "select",
                        attrs: { size: "small" },
                        on: {
                          change: function($event) {
                            return _vm.handleSelectCorpAccount(
                              $event,
                              _vm.signatory
                            )
                          }
                        },
                        model: {
                          value: _vm.signatory.canSelectArrayIndex,
                          callback: function($$v) {
                            _vm.$set(_vm.signatory, "canSelectArrayIndex", $$v)
                          },
                          expression: "signatory.canSelectArrayIndex"
                        }
                      },
                      [
                        _vm._l(_vm.signatory.canSelectArray, function(v, vi) {
                          return _c("el-option", {
                            key: vi,
                            attrs: { value: vi, label: v.name }
                          })
                        }),
                        _vm.signatory.signatoryUserType === 1
                          ? _c("el-option", {
                              attrs: { value: "ManualInput", label: "手动输入" }
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop:
                        _vm.signatory.disabled !== "disabled"
                          ? "signatoryFullName"
                          : "",
                      "show-message": _vm.signatory.disabled !== "disabled"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.signatory.signatoryFullName,
                        disabled: _vm.signatory.disabled === "disabled",
                        placeholder: "请输入签署方名称"
                      },
                      on: {
                        input: function(val) {
                          _vm.signatory.signatoryFullName = val
                          this$1.$emit("qsNameChange", _vm.signatory)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticClass: "select",
                  attrs: {
                    disabled: _vm.signatory.disabled === "disabled",
                    size: "small"
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleSignUserType(_vm.signatory)
                    }
                  },
                  model: {
                    value: _vm.signatory.signatoryUserType,
                    callback: function($$v) {
                      _vm.$set(_vm.signatory, "signatoryUserType", $$v)
                    },
                    expression: "signatory.signatoryUserType"
                  }
                },
                [
                  _c("el-option", { attrs: { value: 0, label: "个人用户" } }),
                  _c("el-option", { attrs: { value: 1, label: "企业用户" } })
                ],
                1
              )
            ],
            1
          ),
          _vm.signatory.signatoryUserType === 0
            ? [
                _vm.signatory.signatoryUserType === 0
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { position: "relative" },
                        attrs: {
                          prop:
                            _vm.signatory.disabled !== "disabled"
                              ? "IDCard"
                              : "",
                          "show-message": _vm.signatory.disabled !== "disabled"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.signatory.disabled === "disabled",
                            placeholder: "请输入中国大陆18位身份证号码"
                          },
                          model: {
                            value: _vm.signatory.IDCard,
                            callback: function($$v) {
                              _vm.$set(_vm.signatory, "IDCard", $$v)
                            },
                            expression: "signatory.IDCard"
                          }
                        }),
                        _vm.signatory.ischange === 1
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "color-success amend-signator amend-tab__form",
                                attrs: { href: "javascript:void (0)" },
                                on: {
                                  click: function($event) {
                                    return _vm.amendSign(_vm.signatory)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm.signatory.signatoryUserType !== 1
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { position: "relative" },
                        attrs: {
                          prop:
                            _vm.signatory.disabled === "disabled" ||
                            _vm.signatory.signatoryUserType === 1
                              ? ""
                              : "BusinessLicenseNo",
                          "show-message": _vm.signatory.disabled !== "disabled"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled:
                              _vm.signatory.disabled === "disabled" ||
                              _vm.signatory.signatoryUserType === 1,
                            placeholder: "请输入营业执照号"
                          },
                          model: {
                            value: _vm.signatory.BusinessLicenseNo,
                            callback: function($$v) {
                              _vm.$set(_vm.signatory, "BusinessLicenseNo", $$v)
                            },
                            expression: "signatory.BusinessLicenseNo"
                          }
                        }),
                        _vm.signatory.ischange === 1
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "color-success amend-signator amend-tab__form",
                                attrs: { href: "javascript:void (0)" },
                                on: {
                                  click: function($event) {
                                    return _vm.amendSign(_vm.signatory)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 11, "false-label": null },
                  model: {
                    value: _vm.signatory.authLevel,
                    callback: function($$v) {
                      _vm.$set(_vm.signatory, "authLevel", $$v)
                    },
                    expression: "signatory.authLevel"
                  }
                },
                [_vm._v("\n          需要人脸识别\n      ")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "danger", size: "small" },
                  on: { click: _vm.closeToolTip }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("p", { staticClass: "tels" }, [
        _c("i", {
          staticClass: "icon icon-btn_tels",
          on: {
            click: function($event) {
              return _vm.telClick($event)
            }
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5d211e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5d211e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/singer-form/index.vue
// module id = oX+t
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 33 35 36 44 45 46